import script from "./InstanceDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./InstanceDetails.vue?vue&type=script&setup=true&lang=js"

import "./InstanceDetails.vue?vue&type=style&index=0&id=4538f250&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4538f250"]])

export default __exports__